import React from 'react';
import { SEO } from '../components/SEO';
import { SEO_CONTENT } from '../data/seoContent';

export const PrivacyPolicy = () => (
  <div className="min-h-screen pt-24 pb-16 bg-gray-50">
    <SEO {...SEO_CONTENT.privacyPolicy} />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-12">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: February 2026</p>

      <div className="prose prose-sm md:prose-base max-w-none text-gray-700 space-y-5 leading-relaxed">
        <p>
          LAMKO Co., Ltd. ("LAMKO", "we", "us") respects your privacy and is committed to protecting your personal data.
          This Privacy Policy explains how we collect, use, retain, and protect information you submit through our website,
          including inquiries and partnership applications.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8">1. Information We Collect</h2>
        <p>
          When you submit an inquiry or partnership application, we collect: name, job title, business email, phone number,
          company name, country of incorporation, project/technical details, uploaded documents, and other information you
          voluntarily provide.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8">2. How We Use Your Data</h2>
        <p>
          We use submitted information solely to evaluate and respond to your inquiry, qualify partnership suitability,
          and, where you have opted in, to send you occasional updates about LAMKO services and industry developments.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8">3. Retention</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Customer inquiry data (CRDMO, CDMO, CMO, Purification, Technical Consultation): retained for up to <strong>3 years</strong>.</li>
          <li>Partnership application data (Become a Partner): retained for up to <strong>5 years</strong>.</li>
        </ul>

        <h2 className="text-xl font-bold text-gray-900 mt-8">4. Confidentiality</h2>
        <p>
          All submitted data - including technical specifications, certifications, and uploaded documents - is treated as
          confidential and is accessible only to authorized LAMKO personnel involved in evaluating your inquiry.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8">5. Your Rights</h2>
        <p>
          You may request access to, correction of, or deletion of your personal data at any time by contacting{' '}
          <a href="mailto:privacy@lamko.co.kr" className="text-teal-700 hover:underline font-medium">privacy@lamko.co.kr</a>.
          You may also withdraw consent for marketing communications at any time via the unsubscribe link in our emails.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8">6. Legal Compliance</h2>
        <p>
          LAMKO protects your data in accordance with applicable data protection laws, including the Korean Personal
          Information Protection Act (PIPA), the EU General Data Protection Regulation (GDPR), and other relevant
          international regulations.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8">7. Contact</h2>
        <p>
          For any privacy-related questions or requests, please contact us at{' '}
          <a href="mailto:privacy@lamko.co.kr" className="text-teal-700 hover:underline font-medium">privacy@lamko.co.kr</a>.
        </p>
      </div>
    </div>
  </div>
);
